<template>
  <div>
    <AccordionCard :state="cards.existingDamage">
      <template v-slot:header>
        {{ $t('existingDamage') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('existingDamageAttachments') }}
        </div>
        <div class="flex-column select">
          <p>
            {{ $t('existingDamageAttachments_description') }}
          </p>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.damageAttachments"
            attachmentType="damageAttachments"
            :deletable="true"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isDamageAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="damageAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isDamageAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('existingDamageNotes') }}
        </div>
        <div class="flex-column select">
          <InputText type="text" v-model="project.enpalReport.existingDamageNotes" />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import AttachmentGallery from '@/components/AttachmentGallery';
import DropzoneUpload from '@/components/DropzoneUpload';
import InputText from 'primevue/inputtext';

export default {
  name: 'ExistingDamage',
  components: {
    AccordionCard,
    AttachmentGallery,
    DropzoneUpload,
    InputText,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isDamageAttachmentsUploadComplete: false,
    };
  },
  computed: { ...mapGetters(['getEnumValues']) },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isDamageAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
